var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"index_bottom"},[_c('div',{staticClass:"index_bottom_bac"},[_c('div',{attrs:{"id":"JYL_footer","data-key":"nemojoy"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }